import {
  skipReadTasksReadTasksSkipPatch,
  SkipReadTasksReadTasksSkipPatchResponse,
  Body_skip_read_tasks_read_tasks_skip_patch,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useSkipTasksMutation = (): UseMutationResult<
  SkipReadTasksReadTasksSkipPatchResponse,
  AxiosError<HTTPValidationError>,
  Body_skip_read_tasks_read_tasks_skip_patch
> => {
  return useMutation<
    SkipReadTasksReadTasksSkipPatchResponse,
    AxiosError<HTTPValidationError>,
    Body_skip_read_tasks_read_tasks_skip_patch
  >({
    mutationFn: async (body) => {
      const response = await skipReadTasksReadTasksSkipPatch({
        body: body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
